import { Loader2 } from "lucide-react";

export function Loading() {
  return (
    <div className="flex w-full h-full justify-center align-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
